/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocPlusIcon24Solid = forwardRef('DocPlusIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2h4.05v5.3a2.75 2.75 0 0 0 2.75 2.75H20V18a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Zm4.875 10a.875.875 0 0 0-1.75 0v2.125H9a.875.875 0 0 0 0 1.75h2.125V18a.875.875 0 0 0 1.75 0v-2.125H15a.875.875 0 0 0 0-1.75h-2.125V12Z" }),
        React.createElement("path", { d: "M20 8.51v.04h-5.2c-.69 0-1.25-.56-1.25-1.25V2.06L20 8.51Z" })));
});
